import styles from "./MobileAppSection.module.scss";
import app from "../../../../assets/images/pages/home/mobile-app/app-store.svg";
import playmarket from "../../../../assets/images/packages/play-store-svgrepo-com (3).svg";
import { useSite } from "../../../../context/TranslationContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
const MobileAppSection = () => {
  const { data } = useSelector((state: RootState) => state.translationData);
  return (
    <div id={styles.mobile_app_section}>
      <div className="container">
        <div className={styles.mobile_app_section}>
          <h1 className={styles.section_title}>{data?.mobile_app_title}</h1>
          <div className={styles.mobile_app_description}>
            <div className={styles.mobile_app_description}>
              {data?.mobile_app_text?.split(/(Colibri)/).map((part, index) =>
                part === "Colibri" ? (
                  <span key={index} className={styles.link}>
                    Colibri
                  </span>
                ) : (
                  part
                ),
              )}
            </div>
          </div>
          <div className={styles.app_buttons}>
            <a
              className={styles.app_btn}
              href="https://apps.apple.com/us/app/colibri-yeni/id6748218706"
            >
              <img src={app} alt="app" />
              <div className={styles.app_content}>
                <p>Downland on the</p>
                <h1>App Store</h1>
              </div>
            </a>
            <a
              className={styles.app_btn}
              href="https://play.google.com/store/apps/details?id=com.colibri.bionet"
            >
              <img src={playmarket} alt="app" />
              <div className={styles.app_content}>
                <p>Get in on</p>
                <h1>Play Store </h1>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppSection;
